import { useState, useEffect } from 'react';
import { useMediaQuery } from 'usehooks-ts'; // Importa useMediaQuery da usehooks-ts

// Definisci il tipo per il ritorno del nostro hook (top e left)
type ToolbarPosition = {
  top: number;
  left: number;
};

function useToolbarPosition(): ToolbarPosition {
  // Usa useMediaQuery per determinare se la larghezza della finestra è sotto i 768px
  const isMobile = useMediaQuery('(max-width:768px)');

  const [position, setPosition] = useState<ToolbarPosition>({
    top: 0,
    left: 0,
  });

  useEffect(() => {
    // Funzione per aggiornare la posizione della toolbar
    const updateToolbarPosition = () => {
      const body = document.body;
      const hasToolbar = body.classList.contains('has-toolbar');
      const isCollapsed = body.classList.contains('has-toolbar-collapsed');

      // Impostazioni di default per top e left
      let top = 0;
      let left = 0;

      // Comportamento quando la larghezza è inferiore a 768px (mobile)
      if (isMobile) {
        if (hasToolbar) {
          top = 100; // Posizione della toolbar per schermi grandi
          left = 0;
        } else if (isCollapsed) {
          top = 20; // Posizione della toolbar ridotta
          left = 0;
        }
      } else {
        // Comportamento per schermi più grandi (>= 768px)
        if (hasToolbar) {
          top = 0; // La toolbar va in alto
          left = 80;
        } else if (isCollapsed) {
          top = 0; // La toolbar ridotta va in alto
          left = 20;
        }
      }

      // Imposta la posizione dello stato
      setPosition({ top, left });
    };

    // Esegui l'aggiornamento della posizione iniziale
    updateToolbarPosition();

    // Aggiungi un observer per il cambiamento delle classi nel body
    const observer = new MutationObserver(updateToolbarPosition);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    // Pulizia al momento della dismount
    return () => {
      observer.disconnect();
    };
  }, [isMobile]); // Usa isMobile come dipendenza per aggiornare quando la larghezza cambia

  return position; // Restituisce un oggetto con top e left
}

export { useToolbarPosition };
